import { crearTabla } from '@plataforma/ui';

import { listarActividadBackoffice } from '../api/backoffice.js';
import { exigirSuperAdmin } from '../guardas.js';

import { crearPaginacion, estadoCarga, estadoError, fechaHora } from './backoffice-ui.js';
import { montarShell } from './shell.js';

const ETIQUETAS = {
  INSERT: 'Creación',
  UPDATE: 'Actualización',
  DELETE: 'Eliminación',
  'super_admin.cambiar_estado_empresa': 'Cambio de estado',
  'super_admin.cambiar_plan_empresa': 'Cambio de plan',
  'super_admin.extender_trial': 'Trial extendido',
  'super_admin.actualizar_plan': 'Plan actualizado',
  'super_admin.crear_plan': 'Plan creado',
  aprobar_solicitud_contratacion: 'Contratación aprobada',
  rechazar_solicitud_contratacion: 'Contratación rechazada',
  crear_solicitud_contratacion: 'Nueva contratación',
  'trial.expirado': 'Trial vencido',
};

export async function vistaActividad(contenedorRaiz) {
  if (!exigirSuperAdmin()) return;

  const contenido = montarShell(contenedorRaiz, '/actividad');
  const estadoVista = { pagina: 1 };

  contenido.innerHTML = `
    <div class="pf-backoffice-header">
      <div>
        <h1>Actividad</h1>
        <p class="pf-texto-suave">Eventos relevantes de operación y negocio.</p>
      </div>
    </div>
    <div id="pf-actividad-tabla">${estadoCarga()}</div>
  `;

  await cargar(contenido, estadoVista);
}

async function cargar(contenido, estadoVista) {
  const destino = contenido.querySelector('#pf-actividad-tabla');
  destino.innerHTML = estadoCarga();

  const { data, error, count } = await listarActividadBackoffice(estadoVista);
  if (error) {
    destino.innerHTML = estadoError('No se pudo cargar actividad.');
    return;
  }

  destino.innerHTML = '';
  destino.appendChild(
    crearTabla({
      filaVacia: 'Todavía no hay actividad registrada.',
      columnas: [
        { titulo: 'Fecha', render: (fila) => fechaHora(fila.creado_en) },
        { titulo: 'Empresa', render: (fila) => fila.empresa?.nombre ?? '—' },
        { titulo: 'Evento', render: (fila) => ETIQUETAS[fila.accion] ?? fila.accion },
        { clave: 'entidad', titulo: 'Entidad' },
        { titulo: 'Resumen', render: (fila) => resumenActividad(fila) },
      ],
      filas: data ?? [],
    }),
  );
  destino.appendChild(
    crearPaginacion({
      total: count ?? 0,
      pagina: estadoVista.pagina,
      alCambiar: async (pagina) => {
        estadoVista.pagina = pagina;
        await cargar(contenido, estadoVista);
      },
    }),
  );
}

function resumenActividad(fila) {
  const detalle = fila.detalle ?? {};
  if (detalle.tipo_cambio)
    return `${detalle.plan_anterior?.nombre ?? '—'} → ${detalle.plan_nuevo?.nombre ?? '—'}`;
  if (detalle.motivo) return detalle.motivo;
  if (detalle.nuevo?.estado) return `Nuevo estado: ${detalle.nuevo.estado}`;
  if (detalle.plan_nombre) return detalle.plan_nombre;
  return '—';
}
